import { ListItemIcon } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Archive from "@material-ui/icons/Archive";
import GetAppIcon from "@material-ui/icons/GetApp";
import SmsFailedIcon from "@material-ui/icons/SmsFailed";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { USER_GROUPS, checkRequiredPermissions } from "../../../Utils/Common";
import { showSidebar } from "../../../redux/actions/sidebarActions";
import CollapseGroup from "../CollapseGroup";

export default function SoftwareModule() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  // Allowed Uswer groups
  return checkRequiredPermissions([USER_GROUPS.SUPER_USER]) ? (
    <CollapseGroup
      mainItemAction={() => {
        history.push("/cpanel/software");
        dispatch(showSidebar(false));
      }}
      mainItemIcon={<Archive />}
      header={t("software.header")}
    >
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/crashlogs");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <SmsFailedIcon />
        </ListItemIcon>
        <ListItemText primary={t("deviceDetails.crashLogs")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/software/releases");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <GetAppIcon />
        </ListItemIcon>
        <ListItemText primary={t("software.releases")} />
      </ListItem>
    </CollapseGroup>
  ) : null;
}
